import { render } from "./JourneysDataTable.vue?vue&type=template&id=506c66bc"
import script from "./JourneysDataTable.vue?vue&type=script&lang=js"
export * from "./JourneysDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__